import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';

import { Button } from '@/Components/shadcn';
import UIStrings from '@/Utils/UIStrings';
import useAcceptInvitationState from '../Hooks/useAcceptInvitationState';
import AccountHasBeenRevoked from './AccountHasBeenRevoked';

function SubmissionError() {
    const { companyName } = useAcceptInvitationState();
    const { logout } = useAuth0();

    const handleOnClick = () => {
        logout({
            returnTo: window.location.origin,
        });
    };

    return (
        <div className="border-border bg-destructive/10 flex flex-col gap-4 rounded-lg border p-2">
            <AccountHasBeenRevoked companyName={companyName} />
            <p className="text-foreground text-sm">{UIStrings.ToTryADifferentAccountPleaseLogout}</p>
            <Button type="button" variant="outline" size="sm" className="bg-background w-20" onClick={handleOnClick}>
                {UIStrings.Logout}
            </Button>
        </div>
    );
}

export default SubmissionError;
